import { EMPTY_LIST } from '../../../../../constants/common'
import {
  getBuildingGroupProfilePathname,
  getBuildingProfilePathname,
} from '../../../../../utils/link'
import { getWebappLinkPrefix } from '../../../../../utils/route'
import {
  BUILDING_REQUIRED_AUDIENCE,
  NEWSBOARD_POST_AUDIENCE,
  NEWSBOARD_POST_AUDIENCE_PERSONAL_STATUS,
  NEWSBOARD_POST_AUDIENCE_REQUEST_BUILDING_GROUP,
  NEWSBOARD_POST_AUDIENCE_TO_ALL_BUILDINGS,
  NEWSBOARD_POST_AUDIENCE_TO_ALL_FRIENDS,
  NEWSBOARD_POST_AUDIENCE_TO_BUILDING,
  NEWSBOARD_POST_TAG_LINK_BUILDING,
  NEWSBOARD_POST_TAG_LINK_BUILDING_GROUP,
} from '../../../Newsboard.constants'

import { HIDE_MESSAGE_POST_TYPES } from './NewsboardPostBodyMessage.constants'

function getAudience(audience, t) {
  return audience.map(item => {
    return {
      Icon: NEWSBOARD_POST_AUDIENCE[item.title].Icon,
      hoverable: NEWSBOARD_POST_AUDIENCE[item.title].hoverable,
      id: item,
      title: t(NEWSBOARD_POST_AUDIENCE[item.title].titleKey),
    }
  })
}

export function parseStatus(status = EMPTY_LIST) {
  return status?.map(item => {
    return {
      Icon: NEWSBOARD_POST_AUDIENCE[NEWSBOARD_POST_AUDIENCE_PERSONAL_STATUS]
        .Icon,
      id: item.id,
      title: item.value,
    }
  })
}

export function parseAudience({ audience, isStaff, t }) {
  if (!isStaff) {
    //TODO replace after excluded on backend
    return getAudience(
      audience.filter(
        item => item.title === NEWSBOARD_POST_AUDIENCE_TO_ALL_FRIENDS
      ),
      t
    )
  }

  return getAudience(audience, t)
}

export function filterByTitle({ title }, search) {
  return title.toLowerCase().includes(search.toLowerCase())
}

export function parseBuildings({
  audience,
  buildingGroups = EMPTY_LIST,
  buildings = EMPTY_LIST,
  t,
}) {
  const buildingsList = buildings.map(item => {
    return {
      ...item,
      ...NEWSBOARD_POST_AUDIENCE[NEWSBOARD_POST_AUDIENCE_TO_BUILDING],
      Icon: NEWSBOARD_POST_AUDIENCE[NEWSBOARD_POST_AUDIENCE_TO_BUILDING].Icon,
    }
  })

  const groupsList = buildingGroups.map(item => {
    return {
      ...item,
      ...NEWSBOARD_POST_AUDIENCE[
        NEWSBOARD_POST_AUDIENCE_REQUEST_BUILDING_GROUP
      ],
      Icon: NEWSBOARD_POST_AUDIENCE[
        NEWSBOARD_POST_AUDIENCE_REQUEST_BUILDING_GROUP
      ].Icon,
      title: item.name,
    }
  })

  const buildingTypesList = [...buildingsList, ...groupsList]

  if (buildingTypesList.length === 0) {
    const requiredBuildingAudience = audience.filter(i =>
      BUILDING_REQUIRED_AUDIENCE.includes(i.title)
    )

    return requiredBuildingAudience.length > 0
      ? [
          {
            ...NEWSBOARD_POST_AUDIENCE[
              NEWSBOARD_POST_AUDIENCE_TO_ALL_BUILDINGS
            ],
            Icon: NEWSBOARD_POST_AUDIENCE[
              NEWSBOARD_POST_AUDIENCE_TO_ALL_BUILDINGS
            ].Icon,
            title: t(
              NEWSBOARD_POST_AUDIENCE[NEWSBOARD_POST_AUDIENCE_TO_ALL_BUILDINGS]
                .titleKey
            ),
          },
        ]
      : EMPTY_LIST
  }

  return buildingTypesList
}

export function isHiddenMessagePostType(data) {
  return HIDE_MESSAGE_POST_TYPES.includes(data?.post_type.title)
}

// `to` is the legacy webapp path segment; building and building-group tags
// are routed to the redesign profiles when those UI sections are available.
export function getListItemLink({
  availableSections,
  id,
  isBuildingGroupProfileNGAvailable,
  to,
}) {
  if (to === NEWSBOARD_POST_TAG_LINK_BUILDING) {
    return getBuildingProfilePathname({ availableSections, id })
  }

  if (to === NEWSBOARD_POST_TAG_LINK_BUILDING_GROUP) {
    return getBuildingGroupProfilePathname({
      id,
      isBuildingGroupProfileNGAvailable,
    })
  }

  return getWebappLinkPrefix(`/${to}/${id}`)
}

export function getRatingPostText(requests) {
  return requests?.[0]?.rating?.feedback?.text
}
